export default "__VITE_ASSET__caf2de4c__"